import DOMPurify from "dompurify";

/**
 * xss
 */
export function filterXSS(string: string) {
    return DOMPurify.sanitize(string, {USE_PROFILES: {html: true}});
}